import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { AddReferredBySchema } from '../schemas';
import { AddReferredByModel, UserProviderValue } from '../models';
import { addReferredBy } from '../services';
import { toast } from 'react-toastify';
import { UserContext } from '../contexts/user.context';

export function useAddReferralCode(onAdded: () => void) {
   const { user, setUser } = useContext<UserProviderValue>(UserContext);

   const addReferredByForm = useForm<AddReferredByModel>({
      resolver: zodResolver(AddReferredBySchema),
      mode: 'onChange',
   });
   const [isLoading, setIsLoading] = useState<boolean>(false);

   const submitAddReferredBy = async (data: AddReferredByModel) => {
      setIsLoading(true);
      const response = await addReferredBy(data.code);

      if (response.error || !response.data) {
         toast.error(response.error?.message || 'Failed to add your referral code');
         setIsLoading(false);
         addReferredByForm.reset();
         return;
      }
      setUser(user ? { ...response.data, primaryWallet: user.primaryWallet, wallets: user.wallets } : response.data);
      toast.success('Referral code added successfully');
      setIsLoading(false);
      onAdded();
   };

   return {
      addReferredByForm,
      isLoading,
      setIsLoading,
      submitAddReferredBy,
   };
}
